import { BookingDiaryEventModel } from './typings/booking-diary.event';
import { SLOT_MINUTES }           from './booking-diary.layout';

export interface BookingDiaryRunModel {
  endMinutes   : number;
  startMinutes : number;
}

// the mechanic's day as runs of taken time, overlaps merged; away and unrostered time count too
export function busyRunsFor (
  events     : Array<BookingDiaryEventModel>,
  date       : string,
  mechanicId : string,
  exceptId   : string = null
) : Array<BookingDiaryRunModel> {
  return ( events || [] )
    .filter(event => event.date === date
      && String(event.mechanicId) === String(mechanicId)
      && !( exceptId && String(event.id) === String(exceptId) ))
    .map(event => ( {
      endMinutes  : event.endMinutes,
      startMinutes: event.startMinutes
    } ))
    .sort(( a, b ) => a.startMinutes - b.startMinutes)
    .reduce(( merged : Array<BookingDiaryRunModel>, run ) => {
      const last = merged[merged.length - 1];

      if ( last && run.startMinutes <= last.endMinutes ) {
        last.endMinutes = Math.max(last.endMinutes, run.endMinutes);

        return merged;
      }

      return merged.concat({ ...run });
    }, []);
}

// what is left of the shop's day once the taken runs are removed
export function freeRunsBetween (
  busy   : Array<BookingDiaryRunModel>,
  opens  : number,
  closes : number
) : Array<BookingDiaryRunModel> {
  const free : Array<BookingDiaryRunModel> = [];
  let from                                 = opens;

  busy.forEach(run => {
    if ( run.startMinutes > from ) {
      free.push({
        endMinutes  : Math.min(run.startMinutes, closes),
        startMinutes: from
      });
    }

    from = Math.max(from, run.endMinutes);
  });

  if ( from < closes ) {
    free.push({
      endMinutes  : closes,
      startMinutes: from
    });
  }

  return free.filter(run => run.endMinutes > run.startMinutes);
}

function firstSlotFrom ( minutes : number ) : number {
  return Math.ceil(minutes / SLOT_MINUTES) * SLOT_MINUTES;
}

// true when the time overlaps a booking, away time or unrostered time on the mechanic's day
export function isTimeTaken (
  events       : Array<BookingDiaryEventModel>,
  date         : string,
  mechanicId   : string,
  startMinutes : number,
  endMinutes   : number,
  exceptId     : string = null
) : boolean {
  return busyRunsFor(events, date, mechanicId, exceptId)
    .some(run => startMinutes < run.endMinutes && endMinutes > run.startMinutes);
}

// every start the length fits at, on the slot boundaries the grid snaps to
export function startsThatFit (
  free     : Array<BookingDiaryRunModel>,
  duration : number
) : Array<number> {
  const starts : Array<number> = [];

  if ( duration <= 0 ) {
    return starts;
  }

  free.forEach(run => {
    for ( let start = firstSlotFrom(run.startMinutes); start + duration <= run.endMinutes; start += SLOT_MINUTES ) {
      starts.push(start);
    }
  });

  return starts;
}

